export default __webpack_public_path__ + "3d59ce3e9d6f49acb2856a03aed17f53.woff";